(() => {
  // Section previews must not double-bind the loader.
  if (window.erOptionalResourcesReady) return;
  window.erOptionalResourcesReady = true;
  const start = () => {
    const config = document.querySelector('[data-er-optional-resources]');
    if (!config) return;
    let entries;
    try { entries = JSON.parse(config.textContent); } catch (_) { return; }
    const pending = new Set(entries);
    const inFlight = new Set();
    const failed = new Set();
    const attempts = new Map();
    const editor = config.dataset.editor === 'true';
    let observer;
    const load = (entry) => {
      if (inFlight.has(entry) || failed.has(entry)) return;
      inFlight.add(entry);
      pending.delete(entry);
      const script = document.createElement('script');
      if (entry.module) script.type = 'module';
      const attempt = attempts.get(entry) || 0;
      attempts.set(entry, attempt + 1);
      const url = new URL(entry.src, document.baseURI);
      // Browsers cache failed module evaluations by URL. A network-recovery
      // retry needs a fresh key, while successful assets retain normal caching.
      if (attempt) url.searchParams.set('er_resource_retry', String(attempt));
      script.src = url.href;
      script.async = true;
      script.dataset.erOptionalScript = entry.selector;
      script.addEventListener('load', () => {
        if (!pending.size) observer?.disconnect();
      }, {once:true});
      script.addEventListener('error', () => {
        inFlight.delete(entry);
        pending.add(entry);
        failed.add(entry);
        script.remove();
        // Never create a mutation/retry loop when a CDN request fails.
        observer?.observe(document.body, {childList:true, subtree:true});
      }, {once:true});
      document.head.appendChild(script);
    };
    const scan = (root) => {
      if (root.nodeType !== 1 && root.nodeType !== 9) return;
      for (const entry of pending) {
        if (editor || root.matches?.(entry.selector) || root.querySelector(entry.selector)) load(entry);
      }
    };
    observer = new MutationObserver(records => {
      // Inspect only added element subtrees; ignore text/attribute animations.
      for (const record of records) for (const node of record.addedNodes) scan(node);
    });
    observer.observe(document.body, {childList:true, subtree:true});
    scan(document);
    document.addEventListener('shopify:section:load', event => scan(event.target));
    window.addEventListener('online', () => { failed.clear(); scan(document); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
